// extracted by mini-css-extract-plugin
export default {"preview":"consentDocumentPreview_preview__8U2Tw","frame":"consentDocumentPreview_frame__F2s5s","state":"consentDocumentPreview_state__oJ6EU"};